module.exports = __webpack_public_path__ + "img/blyde-river-canyon.22751b3e.jpeg";